import { combineReducers, Reducer } from 'redux';
import { connectRouter } from 'connected-react-router';
import { History } from 'history';
// import _merge from 'lodash/merge';
// import lang from 'core/providers/LangProvider/slice';
// import auth from 'providers/AuthProvider/slice';
import general from 'providers/GeneralProvider/slice';
import coreReducer from 'core/store/reducer';
import Plugins from 'plugins';
// import Extensions from 'extensions';
// PLOP: Import reducers below -- DO NOT ERASE
import notification from 'providers/NotificationProvider/slice';

const createRootReducer = (history: History): Reducer => {
  const originalReducer = {
    router: connectRouter(history),
    // lang,
    // auth,
    general,
    // PLOP: Use reducers below -- DO NOT ERASE
    notification,
  };
  // const allReducer = _merge(Plugins.slice, Extensions.slice);
  const reducer = {
    // ...allReducer,
    ...Plugins.slice,
    ...originalReducer,
    ...coreReducer,
  };
  return combineReducers(reducer);
};
export default createRootReducer;
